import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../providers/lang.service';
import { Input } from '@angular/core';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.css']
})
export class ErrorMessageComponent implements OnInit, OnChanges {

  errorMessage : string = '';
  mismatch_user_token_403: string = "";
  no_product_found_200 : string = "";
  same_token_500 :string = "";
  @Input() errorData : any;


  constructor(private langService: LanguageService) { }

  ngOnInit() {
  this.setLabels();

  }

  ngOnChanges(){
    if(this.errorData != undefined){
      if(this.errorData.name == "TimeoutError"){
        this.errorMessage = this.errorData.message;
      }
      if(this.errorData.status_code === 500){
        this.errorMessage = this.same_token_500;
      }else if(this.errorData.status_code === 200 || this.errorData.status === 200){
        this.errorMessage = this.errorData.error_message;
      }
      else if(this.errorData.status_code === 403){
        this.errorMessage = this.errorData.error_message;
      }    
    }
  }

  setLabels(){
    
    this.langService.getLangLabelValue("403_mismatch_user_token").then(result => {
      this.mismatch_user_token_403 = result;      
    });
    this.langService.getLangLabelValue("200_no_product_found").then(result => {
      this.no_product_found_200 = result;      
    });
    this.langService.getLangLabelValue("500_same_token").then(result => {
      this.same_token_500 = result;      
    }); 

  }

}



// WEBPACK FOOTER //
// ./src/app/error-message/error-message.component.ts